import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import leftArrow from 'shared/assets/images/left-arrow-line.svg';
import greyArrow from 'shared/assets/images/angle-gray.svg';
import rightArrow from 'shared/assets/images/right-arrow-line.svg';

import Link from 'shared/components/Link';

import s from './Breadcrumbs.css';

class Breadcrumbs extends React.Component {
  static propTypes = {
    prev: PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
    links: PropTypes.arrayOf(
      PropTypes.shape({
        title: PropTypes.string.isRequired,
        link: PropTypes.string.isRequired,
      }),
    ).isRequired,
    current: PropTypes.string,
    next: PropTypes.shape({
      title: PropTypes.string.isRequired,
      link: PropTypes.string.isRequired,
    }),
  };

  static defaultProps = {
    prev: null,
    next: null,
    current: null,
  };

  render() {
    const { prev, links, next, current } = this.props;

    return (
      <div className={s.root}>
        <div className={s.flexRow}>
          <div className={cx(s.container, { [s.left]: !!next })}>
            {prev &&
              <span>
                <Link to={''} className={s.back}>
                  <img src={leftArrow} width={12} alt="" />&nbsp;{prev.title}
                </Link>
                <img className={s.divider} src={greyArrow} width="14" alt="" />
              </span>}

            {links &&
              links.map(({ title, link }, i) =>
                <span className={s.select} key={title}>
                  <Link to={link} className={s.select}>
                    {title}
                  </Link>
                  {(i !== links.length - 1 || current) &&
                    <img className={s.divider} src={greyArrow} width="14" alt="" />}
                </span>,
              )}

            {current &&
              <span className={`${s.select} ${s.current}`}>
                {current}
              </span>}
          </div>

          {next &&
            <div className={s.right}>
              <Link to={next.link} className={s.next} onClick={this.handleNextAdvertClick}>
                {next.title}&nbsp;<img src={rightArrow} width={12} alt="" />
              </Link>
            </div>}
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Breadcrumbs);



// WEBPACK FOOTER //
// ./src/desktop/components/Breadcrumbs/Breadcrumbs.js